"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var helpers_1 = require("../../helpers");
var getFlexStyleForColumn_1 = __importDefault(require("../utils/getFlexStyleForColumn"));
var features_1 = require("../features");
var utils_1 = require("../utils");
var types_1 = require("../types");
var getJustifyContent = function (justify) {
    switch (justify) {
        case types_1.GRID_COLUMN_JUSTIFY.center:
            return 'center';
        case types_1.GRID_COLUMN_JUSTIFY.right:
            return 'flex-end';
        default:
            return 'flex-start';
    }
};
var BodyCell = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", ";\n    font-weight: ", ";\n    font-family: ", ";\n    line-height: ", ";\n\n    height: 100%;\n    box-sizing: border-box;\n\n    display: flex;\n    align-items: center;\n    justify-content: ", ";\n\n    color: ", ";\n\n    ", "\n\n    ", "\n"], ["\n    font-size: ", ";\n    font-weight: ", ";\n    font-family: ", ";\n    line-height: ", ";\n\n    height: 100%;\n    box-sizing: border-box;\n\n    display: flex;\n    align-items: center;\n    justify-content: ", ";\n\n    color: ",
    ";\n\n    ",
    "\n\n    ",
    "\n"])), helpers_1.FONT_SIZE_M, helpers_1.BASE_FONT_NORMAL_WEIGHT, helpers_1.BASE_FONT_FAMILY, helpers_1.FONT_LINE_HEIGHT_M, function (_a) {
    var justify = _a.justify;
    return getJustifyContent(justify);
}, function (_a) {
    var disabled = _a.disabled, inactive = _a.inactive, theme = _a.theme;
    if (disabled || inactive) {
        return theme.colorTextLight;
    }
    return theme.colorTextMain;
}, function (_a) {
    var isSelectionColumn = _a.isSelectionColumn;
    return !isSelectionColumn && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            padding: ", " ", " ", " ", ";\n        "], ["\n            padding: ", " ", " ", " ", ";\n        "])), helpers_1.SPACING_S, helpers_1.SPACING_L, helpers_1.SPACING_S, helpers_1.SPACING_S);
}, function (_a) {
    var totalColumn = _a.totalColumn, disabled = _a.disabled, theme = _a.theme;
    return totalColumn && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            background-color: ", ";\n            font-weight: ", ";\n        "], ["\n            background-color: ",
        ";\n            font-weight: ", ";\n        "])), disabled
        ? theme.colorBackgroundNeutralLight
        : theme.colorHighlightNotification, helpers_1.BASE_FONT_BOLD_WEIGHT);
});
var StyledGridRowContainer = styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    display: flex;\n    box-sizing: border-box;\n    height: 100%;\n\n    ", "\n    \n    ", "\n    \n    ", "\n\n    ", "\n    \n        ", "\n\n        ", "\n\n        ", "\n"], ["\n    display: flex;\n    box-sizing: border-box;\n    height: 100%;\n\n    ",
    "\n    \n    ",
    "\n    \n    ",
    "\n\n    ",
    "\n    \n        ",
    "\n\n        ",
    "\n\n        ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        border-bottom: 1px solid ", ";\n        color: ", ";\n    "], ["\n        border-bottom: 1px solid ", ";\n        color: ", ";\n    "])), theme.colorBorderGrid, theme.colorTextMain);
}, function (_a) {
    var inactive = _a.inactive, theme = _a.theme;
    return inactive && styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n            background-color: ", ";\n            color: ", ";\n            ", " {\n                background-color: ", ";\n            }\n        "], ["\n            background-color: ", ";\n            color: ", ";\n            ", " {\n                background-color: ", ";\n            }\n        "])), theme.colorBackgroundDisabled, theme.colorTextLight, BodyCell, theme.colorBackgroundDisabled);
}, function (_a) {
    var disabled = _a.disabled, gridDisabled = _a.gridDisabled, theme = _a.theme;
    return !disabled &&
        !gridDisabled && styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n            &:hover {\n                background-color: ", ";\n                ", " {\n                    background-color: ", ";\n                }\n            }\n\n            &:active {\n                background-color: ", ";\n                ", " {\n                    background-color: ", ";\n                }\n            }\n        "], ["\n            &:hover {\n                background-color: ", ";\n                ", " {\n                    background-color: ", ";\n                }\n            }\n\n            &:active {\n                background-color: ", ";\n                ", " {\n                    background-color: ", ";\n                }\n            }\n        "])), theme.colorHighlightLight, BodyCell, theme.colorHighlightLight, theme.colorHighlightDark, BodyCell, theme.colorHighlightDark);
}, function (_a) {
    var selected = _a.selected, theme = _a.theme;
    return selected && styled_components_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n            background-color: ", "};\n            ", " {\n                background-color: ", ";\n            }\n            &:hover {\n                background-color: ", ";\n                ", " {\n                    background-color: ", ";\n                }\n            }\n        "], ["\n            background-color: ", "};\n            ", " {\n                background-color: ", ";\n            }\n            &:hover {\n                background-color: ", ";\n                ", " {\n                    background-color: ", ";\n                }\n            }\n        "])), theme.colorHighlightDark, BodyCell, theme.colorHighlightDark, theme.colorHighlightDark, BodyCell, theme.colorHighlightDark);
}, function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return disabled && styled_components_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n                &,\n                &:hover,\n                &:active {\n                    background-color: ", ";\n                    color: ", ";\n                    ", " {\n                        background-color: ", ";\n                    }\n                }\n            "], ["\n                &,\n                &:hover,\n                &:active {\n                    background-color: ", ";\n                    color: ", ";\n                    ", " {\n                        background-color: ", ";\n                    }\n                }\n            "])), theme.colorBackgroundDisabled, theme.colorTextLight, BodyCell, theme.colorBackgroundDisabled);
}, function (_a) {
    var gridDisabled = _a.gridDisabled, selected = _a.selected, theme = _a.theme;
    return gridDisabled &&
        selected && styled_components_1.css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n                &,\n                &:hover,\n                &:active {\n                    background-color: ", ";\n                    color: ", ";\n                    ", " {\n                        background-color: ", ";\n                    }\n                }\n            "], ["\n                &,\n                &:hover,\n                &:active {\n                    background-color: ", ";\n                    color: ", ";\n                    ", " {\n                        background-color: ", ";\n                    }\n                }\n            "])), theme.colorBackgroundDisabled, theme.colorTextLight, BodyCell, theme.colorBackgroundDisabled);
}, function (_a) {
    var gridDisabled = _a.gridDisabled, theme = _a.theme;
    return gridDisabled && styled_components_1.css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n                &,\n                &:hover,\n                &:active {\n                    color: ", ";\n                }\n            "], ["\n                &,\n                &:hover,\n                &:active {\n                    color: ", ";\n                }\n            "])), theme.colorTextLight);
});
exports.GridRowContainer = helpers_1.createUIElement('GridRowContainer', function (_a, ref) {
    var className = _a.className, disabled = _a.disabled, inactive = _a.inactive, gridDisabled = _a.gridDisabled, selected = _a.selected, children = _a.children, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "disabled", "inactive", "gridDisabled", "selected", "children", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (react_1.default.createElement(StyledGridRowContainer, __assign({}, rest, { "data-selector-id": rest['data-selector-id'], className: "vm-GridRowContainer " + className, disabled: disabled, inactive: inactive, gridDisabled: gridDisabled, selected: selected, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }), children));
});
exports.rowCellId = 'grid-row-cell';
exports.rowSelectionCellId = 'grid-row-selection-cell';
exports.rowToggleableCellId = 'grid-row-toggleable-cell';
exports.rowWrapId = 'grid-row-wrap';
function defaultGridRowContainerRenderer(_a) {
    var selected = _a.selected, rowDisabled = _a.rowDisabled, inactive = _a.inactive, gridDisabled = _a.gridDisabled, children = _a.children;
    return (react_1.default.createElement(exports.GridRowContainer, { selected: selected, disabled: rowDisabled, gridDisabled: gridDisabled, inactive: inactive }, children));
}
function createRow(_a) {
    var _b = _a === void 0 ? {} : _a, isDisabled = _b.isDisabled, isInactive = _b.isInactive, _c = _b.containerRenderer, containerRenderer = _c === void 0 ? defaultGridRowContainerRenderer : _c;
    return function GridRow(rowProps) {
        var _a, _b;
        var _c = features_1.useGridContext(), _d = _c.state, data = _d.data, _e = _d.disabled, gridDisabled = _e === void 0 ? false : _e, rowHeight = _d.rowHeight, selection = _d.selection, columnsWidth = _d.columnsWidth, onRowClick = _c.onRowClick, onRowDoubleClick = _c.onRowDoubleClick, onRowContextMenu = _c.onRowContextMenu, onSelectionChange = _c.onSelectionChange;
        var _f = features_1.useGridToggleableContext(), visibleColumns = _f.visibleColumns, rowWidth = _f.rowWidth;
        var rowIndex = rowProps.rowIndex, style = rowProps.style, isScrolling = rowProps.isScrolling;
        var rowData = data[rowIndex];
        var selected = selection
            ? !!selection.selected.find(function (row) { return rowData[selection.field] === row[selection.field]; })
            : false;
        var cells = [];
        var rowDisabled = (_a = isDisabled === null || isDisabled === void 0 ? void 0 : isDisabled({ rowData: rowData, rowIndex: rowIndex })) !== null && _a !== void 0 ? _a : false;
        var disabled = gridDisabled || rowDisabled;
        var inactive = (_b = isInactive === null || isInactive === void 0 ? void 0 : isInactive({ rowData: rowData, rowIndex: rowIndex })) !== null && _b !== void 0 ? _b : false;
        visibleColumns.forEach(function (column, columnIndex) {
            var _a = column.props, field = _a.field, cellRenderer = _a.cell, totalColumn = _a.totalColumn, isSelectionColumn = _a.isSelectionColumn, isToggleColumn = _a.isToggleColumn, justify = _a.justify, tooltipMaxWidth = _a.tooltipMaxWidth;
            var cellData = field ? rowData[field] : undefined;
            var width = columnsWidth[column.key];
            cells.push(react_1.default.createElement("div", { "data-selector-id": isToggleColumn
                    ? exports.rowToggleableCellId
                    : isSelectionColumn
                        ? exports.rowSelectionCellId
                        : exports.rowCellId, key: "Row-" + rowIndex + "-Col-" + columnIndex, onDoubleClick: function (event) {
                    var _a, _b;
                    if (disabled) {
                        return;
                    }
                    event.preventDefault();
                    event.stopPropagation();
                    if (onRowDoubleClick) {
                        (_b = (_a = document.getSelection) === null || _a === void 0 ? void 0 : _a.call(document)) === null || _b === void 0 ? void 0 : _b.empty();
                        onRowDoubleClick === null || onRowDoubleClick === void 0 ? void 0 : onRowDoubleClick({
                            rowIndex: rowIndex,
                            dataItem: rowData,
                            nativeEvent: event.nativeEvent,
                            syntheticEvent: event
                        });
                    }
                }, style: getFlexStyleForColumn_1.default(column, { width: width }) },
                react_1.default.createElement(BodyCell, { disabled: disabled, inactive: inactive, totalColumn: totalColumn, isSelectionColumn: isSelectionColumn, justify: justify }, cellRenderer === null || cellRenderer === void 0 ? void 0 : cellRenderer({
                    cellData: cellData,
                    isScrolling: isScrolling,
                    isRowDisabled: isDisabled,
                    disabled: disabled,
                    inactive: inactive,
                    rowData: rowData,
                    rowIndex: rowIndex,
                    columnWidth: width,
                    justify: justify,
                    tooltipMaxWidth: tooltipMaxWidth
                }))));
        });
        var flattenedStyle = __assign(__assign({}, style), { height: rowHeight, overflow: 'hidden', width: rowWidth });
        return (react_1.default.createElement("div", { "data-selector-id": exports.rowWrapId, onClick: function (e) {
                var keyboard = {
                    meta: e.nativeEvent.metaKey,
                    ctrl: e.nativeEvent.ctrlKey,
                    shift: e.nativeEvent.shiftKey
                };
                if (disabled) {
                    return;
                }
                onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange({
                    selected: utils_1.updateSelected({
                        selection: selection,
                        rowData: rowData,
                        isRowDisabled: isDisabled,
                        rowClick: true,
                        keyboard: keyboard,
                        data: data
                    }),
                    current: { rowIndex: rowIndex, rowData: rowData }
                });
                onRowClick === null || onRowClick === void 0 ? void 0 : onRowClick({
                    rowIndex: rowIndex,
                    dataItem: rowData,
                    nativeEvent: e.nativeEvent,
                    syntheticEvent: e
                });
            }, onContextMenu: function (e) {
                e.preventDefault();
                if (disabled) {
                    return;
                }
                var keyboard = {
                    meta: e.nativeEvent.metaKey,
                    ctrl: e.nativeEvent.ctrlKey,
                    shift: e.nativeEvent.shiftKey
                };
                onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange({
                    selected: utils_1.updateSelected({
                        selection: selection,
                        rowData: rowData,
                        isRowDisabled: isDisabled,
                        rowClick: true,
                        keyboard: keyboard,
                        data: data,
                        isContextClick: true
                    }),
                    current: { rowIndex: rowIndex, rowData: rowData }
                });
                onRowContextMenu === null || onRowContextMenu === void 0 ? void 0 : onRowContextMenu({
                    rowIndex: rowIndex,
                    dataItem: rowData,
                    nativeEvent: e.nativeEvent,
                    syntheticEvent: e
                });
            }, style: flattenedStyle }, containerRenderer === null || containerRenderer === void 0 ? void 0 : containerRenderer({
            selected: selected,
            rowDisabled: rowDisabled,
            inactive: inactive,
            gridDisabled: gridDisabled,
            rowIndex: rowIndex,
            rowData: rowData,
            children: cells
        })));
    };
}
exports.createRow = createRow;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
//# sourceMappingURL=createRow.js.map